import { useEffect, useRef, useState } from "react";

import { triggeredDebounce } from "../utils/triggeredDebounce";


const useChainedLoading = (loaders: boolean[], ms=1000): boolean => {
  const [loading, setLoading] = useState(true);

  const func = ($loading: unknown) => {
    setLoading($loading as boolean);
  };

  const debounceRef = useRef<((val: boolean) => void) | null>(null);

  useEffect(() => {
    if (!debounceRef.current) {
      debounceRef.current = triggeredDebounce(func, ms);
    }
  }, []);

  useEffect(() => {
    if (!debounceRef.current) return;

    debounceRef.current(loaders.some(Boolean));
  }, [loaders]);

  return loading;
};

export default useChainedLoading;
